module.exports = __webpack_public_path__ + "static/gallery_yarra_4-1b06768382503030ac15bafbbb9829e9.jpg";